<div class="bento-box-container pagelayout-header">
  <mat-toolbar class="{{headerClass}} header-bottom-class">
    <div class="d-flex app-header align-items-center">
      <div (click)="navigateToReports()" class="header-logo">
        <img src="/assets/images/sita_logo_header.svg" alt="brand logo" class="w-100" />
      </div>
      <div class="vertical-divider"></div>
      <div class="header-title">Bag Radar</div>
    </div>
    <div *ngIf="isLoggedIn" mat-icon-button aria-label="icon-button" matTooltipPosition="before"
      class="d-flex app-header justify-content-end align-items-center header-usermenu-anchor">
      <div name="settings"  class="header-user-info">     
        <button class="help-icon" type="button" aria-label="Help" (click)="goToDocs()">
          <img src="assets/icons/help-icon.svg" alt="" class="help-icon__img" />
        </button>
        <div class="divider"></div>
        <div class="d-flex flex-column user-text-info" [matMenuTriggerFor]="menu">
          <span class="user-username">{{username}}</span>
          <span class="user-organization">{{customerName}}</span>
        </div>
        <img [matMenuTriggerFor]="menu" src="assets/icons/Avatar No Image - Small.svg" alt="Custom Icon" class="header-usermenu-img" />
        <img [matMenuTriggerFor]="menu" src="assets/icons/icon_caret_left.svg" alt="Custom Icon" class="img-icon-small" />
      </div>
    </div>
    <mat-menu #menu="matMenu" class="header-user-menu">
      <div name="menusettings" id="menu-settings" mat-icon-button aria-label="icon-button"
        class="d-flex app-header align-items-center justify-content-end">
        <div class="d-flex align-items-center menu-user-info">
          <div class="d-flex flex-column user-text-info">
            <span class="user-username">{{username}}</span>
            <span class="user-organization">{{customerName}}</span>
          </div>
          <img src="assets/icons/Avatar No Image - Small.svg" alt="Custom Icon" class="header-usermenu-img" />
          <img src="assets/icons/Caret_.svg" alt="Custom Icon" class="img-icon-small" />
        </div>
      </div>
      <div class="d-flex flex-column usermenu-action-grp">
        <div class="align-items-center justify-content-end header-usermenu-item">
          <button mat-menu-item (click)="openPolicy()">
            <span>Privacy policy</span>
          </button>

        </div>
        <div class="align-items-center justify-content-end header-usermenu-item">
          <button name="changepassword" mat-menu-item (click)="changePassword()">
            Change password</button>
        </div>

      </div>
      <div class="d-flex align-items-center justify-content-end header-usermenu-item">
        <button name="logout" mat-menu-item (click)="exitApp()">
          <img src="assets/icons/icon_logout.svg" alt="Custom Icon" class="img-icon-small" />

          Logout</button>
      </div>
    </mat-menu>
  </mat-toolbar>
</div>
